import React, { useState, useEffect } from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleService from '../../components/Service/SingleService';

import serviceIcon1 from '../../assets/img/service/style1/1.png'; // Default fallback image

const Service = () => {
    const [services, setServices] = useState([]);  // State to store services data
    const [loading, setLoading] = useState(true);  // State for loading status
    const [error, setError] = useState(null);  // State for error handling

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch('https://yautiktechnology.com/api/solution', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include', // Include credentials (cookies) if necessary
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch services');
                }

                const data = await response.json(); // Parse the response data
                setServices(data);  // Update services state
                setLoading(false);  // Set loading to false once data is fetched
            } catch (error) {
                setError(error.message);  // Set error message if fetching fails
                setLoading(false);
            }
        };

        fetchServices(); // Call the fetch function
    }, []); // Empty dependency array to fetch data on component mount

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="rs-services main-home style2 pt-120 pb-100 md-pt-80 md-pb-60">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-46"
                    subtitleClass="sub-text style-bg"
                    subtitle="Solutions"
                    titleClass="title title2"
                    title="Over a Year’s IT & Technology Solutions Includes"
                />
                <div className="row">
                    {services.map((service, index) => (
                        <div key={index} className="col-lg-4 col-md-6 mb-20">
                            <SingleService
                                itemClass="services-item shape1"
                                serviceImage={service.imageUrl || serviceIcon1} // Use API-provided image or fallback to default
                                subtitle={service.sectionName || "No Title Available"} // Fallback if subtitle is missing
                                Text={service.content || "No description available"} // Fallback if text is missing
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Service;
